import PropTypes from 'prop-types';
import styles from './Alert.module.scss';

const Alert = ({ children, variant, className, role, ...props }) => {
    return (
        <div
            className={[styles[variant], className].join(' ')}
            role={role}
            {...props}
        >
            {children}
        </div>
    );
};

Alert.proptypes = {
    variant: PropTypes.oneOf(['primary', 'secondary', 'error', 'warning', 'success', 'info'])
};

Alert.defaultProps = {
    children: PropTypes.any,
    variant: 'primary',
    role: 'alert'

};

export default Alert;
